import React from 'react'
import { Link } from 'react-router-dom'
import { Card, Text } from '@liquidcollectibles/uikit'
import { NftCollection } from 'state/collectibles/types'

const CollectionCard = ({ collection }: { collection: NftCollection }) => (
  <Link to={`/collection/${collection.nftAddress}`}>
    <Card style={{ borderRadius: 6 }}>
      <img src={`/images/home/collage/${collection.collageImage}.png`} alt="Collection img" style={{ width: '100%' }} />
      <Text bold style={{ padding: '8px 16px' }}>
        {collection.name}
      </Text>
    </Card>
  </Link>
)

export default CollectionCard
